// extracted by mini-css-extract-plugin
module.exports = {"headerTab":"i9n1o","highlighter":"r4SaT","hide":"v7wjb","tabList":"Lx1NT","moreMenuDots":"sSokw","active":"qOYZy","themewhite":"uDjAa","dots":"F7ZpZ","moreMenuItems":"Q9qDe"};